// Calls onSilent after the speaker pauses (quietMs), if nobody speaks for 8s, or after 60s.
export function watchSilence(stream, onSilent, quietMs = 1000) {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  const an = ctx.createAnalyser();
  ctx.createMediaStreamSource(stream).connect(an);
  const buf = new Uint8Array(an.fftSize);
  const started = Date.now();
  const state = { spoke: false };
  let lastLoud = started;
  const timer = setInterval(() => {
    an.getByteTimeDomainData(buf);
    const rms = Math.sqrt(buf.reduce((a, v) => a + (v - 128) ** 2, 0) / buf.length);
    const t = Date.now();
    if (rms > 6) { state.spoke = true; lastLoud = t; }
    if ((state.spoke && t - lastLoud > quietMs) || (!state.spoke && t - started > 8000) || t - started > 60000) onSilent();
  }, 100);
  state.close = () => { clearInterval(timer); ctx.close(); };
  return state;
}
